/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Preview_More_Blocks_SuffixInputs */



/**
* | output |
* | --- |
* | "more blocks not shown" |
*
* @param {Plain_Text_Import_Preview_More_Blocks_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_preview_more_blocks_suffix = /** @type {((inputs?: Plain_Text_Import_Preview_More_Blocks_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Preview_More_Blocks_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("blocs supplementaires non affiches")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Blöcke werden nicht angezeigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("altri blocchi non mostrati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("больше блоков не показано")
	if (locale === "es") return /** @type {LocalizedString} */ ("más bloques no mostrados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更多未显示的方块")
	if (locale === "ja") return /** @type {LocalizedString} */ ("その他のブロックは表示されません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("और ब्लॉक नहीं दिखाए गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais blocos não exibidos")
	return /** @type {LocalizedString} */ ("more blocks not shown")
});